import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonService } from '../../core/services/common.service';
import { Router, RouterModule } from '@angular/router';
import { MiddlewareService } from '../../core/services/middleware.service';
import { apiURL } from '../../../assets/data/api-url';
import { ApiResponse } from '../../core/enums/api-response.enum';

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [TranslateModule, CommonModule, RouterModule],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss',
})
export class FaqComponent {
  @HostListener('click', ['$event.target'])
  onClick(target: HTMLElement) {
    if (target.classList.contains('contact-link')) {
      this.router.navigate([this.commonService.getRouteStartIndex() + 'contact-us']);
    }
  }
  @ViewChild('contactUs') contactUs!: ElementRef;
  isDarkMode: boolean = false;
  faqData: any;

  constructor(private commonService: CommonService, public router: Router, private _middlewareService: MiddlewareService, private translateService: TranslateService) {
    this.detectTheme();
    this.getFAQData();
    this.translateService.onLangChange.subscribe(() => {
      this.getFAQData();
    });
  }

  detectTheme() {
    if (this.commonService.isBrowser) {
      const prefersDark =
        window.matchMedia &&
        window.matchMedia('(prefers-color-scheme: dark)').matches;
      this.isDarkMode = prefersDark;
    }
  }
  toggleAnswer(sectionIndex: number, faq: any): void {
    faq.expanded = !faq.expanded;
  }

  getFAQData() {
    this._middlewareService
      .callGetMiddleware(`${apiURL.getFAQData}?lang=${this.translateService.currentLang}`)
      .subscribe(
        (response) => {
          if (response?.code === ApiResponse.OK) {
            this.faqData = response?.result?.data;
          }
        });
  }
}
